import { combineReducers } from "redux";

import counter from "../features/admin/homepage/counter/Slice";

import socialmedia from "../features/admin/homepage/socialmedia/Slice";

import homebanner from "../features/admin/homepage/homebanner/Slice";

import common from "../features/admin/common/Slice";

import service from "../features/admin/homepage/service/Slice";

import notice from "../features/admin/homepage/notice/Slice";

const homepage = combineReducers({
  counter,
  socialmedia,
  homebanner,
  common,
  service,
  notice,
});

export default homepage;
